import React from "react";

export default function TechStack({ tech }) {
  return (
    <div>
      <div
        style={{
          width: "90px",
          height: "25px",

          backgroundColor: "  #202a44",
          color: "white",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          // border: " 2px solid skyblue",
          borderRadius: "15px",
          fontSize: "13px",
          gap: "5px",
        }}
      >
        <img src={tech.img} alt="" style={{ width: "15px", height: "15px" }} />
        <span sx={{ fontFamily: "g Game TC", fontStyle: "sans-serif" }}>
          {tech.name}
        </span>
      </div>
    </div>
  );
}
